'use strict';
angular.module('MW.Framework.CoreCompanyService', ['ngCookies', 'MW.Framework.CoreCommon', 'MW.Framework.EntitlementService', 'MW.Framework.CoreUserService', 'MW.Framework.TranslationService', 'Configuration', 'MW.Framework.EntitlementService', 'MW.Framework.CoreLocationService'])
    .service('CoreCompanyService', ['$http', '$rootScope', '$timeout', '$injector', '$q', '$window', '$cookies', 'CoreCommon', 'CoreUserService', 'translationService', 'DASHBOARD_SERVICES_URL', 'GYDA_COOKIE_DOMAIN', 'EntitlementService', 'CoreLocationService',
function($http, $rootScope, $timeout, $injector, $q, $window, $cookies, CoreCommon, CoreUserService, translationService, DASHBOARD_SERVICES_URL, GYDA_COOKIE_DOMAIN, EntitlementService, CoreLocationService) {
    var current,
        token,
        CoreCompanyService,
        loadCurrentAuthenticatedCompany,
        waitForCurrentFromAuth = $q.defer();

    CoreCompanyService = {
        companyIsSwitching: {},
        setCurrent: function setCurrent(company) {
            current = company;

            // this is a bit odd but we first resolve the existing promise in case
            // anyone was waiting on it.  we then create a new promise for the next
            // guy that asks for it and resolve it immediately with the new value.
            // that way the next guy that asks gets the new value (not the already
            // resolved one) until the next new value comes along
            waitForCurrentFromAuth.resolve(current);
            waitForCurrentFromAuth = $q.defer();
            waitForCurrentFromAuth.resolve(current);
        },

        /**
         * Returns the current company object (which may not be set yet!) or a promise that will resolve to the
         * current company once auth is complete.  The latter is preferred.
         *
         * @param boolean waitForAuth If true we'll return a promise that will resolve once auth is complete
         * @returns {*}
         */
        getCurrent: function getCurrent(waitForAuth){
            return (waitForAuth ? waitForCurrentFromAuth.promise : current);
        },

        getName: function getName() {
            return CoreCommon.isUsable(current) ? current.name : '';
        },
        getCountry: function getCountry() {
            return CoreCommon.isUsable(current) ? current.country : '';
        },
        isModuleEnabled: function isModuleEnabled(name) {
            return (typeof current.modules !== 'undefined' && typeof current.modules[name] !== 'undefined' && current.modules[name].enabled);
        },
        getId: function getId() {
            return CoreCommon.isUsable(current) && CoreCommon.isUsable(current._id) ? current._id : null;
        },
        getAuthToken: function getAuthToken() {
            return token;
        },
        setAuthToken: function setAuthToken(_token) {
            token = _token;

            loadCurrentAuthenticatedCompany();
        },
        getAuthToken: function getAuthToken() {
            return token;
        },
        setAuthToken: function setAuthToken(_token) {
            token = _token;

            loadCurrentAuthenticatedCompany();
        },
        resetTokenCookie: function resetTokenCookie(){
            var currentHostName = window.location.hostname
            let domain = 'https://v1.staging.identity.meltwater.io';
            if(currentHostName.indexOf(".com") !== -1) {
                domain = 'https://v1.identity.meltwater.io';
            }
            $http.get(domain+'/auth/resetToken?rememberMe='+$cookies.get('gydaRemember')).then(function(responseData) {
                if(responseData !== undefined && responseData.data !== undefined && responseData.data.token !== undefined && Object.keys(CoreCompanyService.companyIsSwitching).length <= 0) {
                    CoreCompanyService.createNewCookie(responseData);
                }
            });
        },
        createNewCookie: function setUpNewCookie(cookieData) {
            // Login Feature Toggle
            // NOTE: create new cookie not supported by feature toggle
            if($window.loginOrigin) {
                return;
            }

            CoreCompanyService.setAuthToken(cookieData.data.token);
            var rememberCookie = $cookies.get('gydaRemember');
            var expireDays = 1;
            if(rememberCookie === 1){
                expireDays = 7;
            }
            var exDate = new Date();
            exDate.setDate(exDate.getDate() + expireDays);
console.log('Creating new cookie for domain [' + GYDA_COOKIE_DOMAIN + ']');
            // Temp removal of old cookie
            $cookies.remove('gydaToken', {domain: 'insight-report.meltwater.com/'});
            $cookies.putObject('gydaToken', cookieData.data, {expires: exDate, path: '/', domain: GYDA_COOKIE_DOMAIN});
            $cookies.put('gydaRemember', rememberCookie, {expires: exDate, path: '/', domain: GYDA_COOKIE_DOMAIN});
        },
        getEntitlementId: function getEntitlementId() {
            return CoreCommon.isUsable(current) ? current.entitlementCustomerId : null;
        },
        getOpportunityId: function getOpportunityId() {
            return CoreCommon.isUsable(current) && current.opportunityId ? current.opportunityId : null;
        },
        // canUserAccessCompany: function canUserAccessCompany(companyId, userId) {
        //     var deferred = $q.defer();

        //     if(companyId === undefined) {
        //         deferred.reject('CompanyId is not defined.');
        //     }
        //     else if(userId === undefined) {
        //         deferred.reject('UserId is not defined.');
        //     } else {

        //         $http.get(DASHBOARD_SERVICES_URL+'/company/' + companyId +  '/canUserAccess/' + userId).then(function(response) {
        //             deferred.resolve(response.data);
        //         });
        //     }

        //     return deferred.promise;
        // },
    };

    /**
     * Switches the user over to the specified company. This causes the application
     * to reload to take effect.
     *
     * @param companyId The ID of the company to switch to.
     * @returns {Promise} True on success and about to reload; Error reason code on rejection.
     */
    CoreCompanyService.switchCompany = function switchCompany (companyId) {
        var deferral = $q.defer();

        CoreCompanyService.companyIsSwitching[companyId] = true;
        $http.put(CoreLocationService.getWebsiteUrl() + '/switchCompany/' + companyId)
            .then(function reloadApplication() {
                    CoreLocationService.reloadApplication();
                    deferral.resolve();
            })
            .catch(function unwrapErrorCode (error) {
                var reason = (error && error.data && error.data.reason) ? error.data.reason : error.message;
                delete CoreCompanyService.companyIsSwitching[companyId];
                deferral.reject(reason);
            });

        return deferral.promise;
    };

    loadCurrentAuthenticatedCompany = function loadCurrentAuthenticatedCompany() {
        var currentHostName = window.location.hostname
        let domain = 'https://v1.staging.identity.meltwater.io';
        // if(DASHBOARD_SERVICES_URL === 'https://app.meltwater.com/dashboard_services/v2') {
        if(currentHostName.indexOf(".com") !== -1) {
            domain = 'https://v1.identity.meltwater.io';
        }
        $http.get(domain).then(function(response) {
                if (response.status === 200 && response.data.company !== undefined) {

                    var doCheckUserTimezone = true;
                    if(response.data.user.language === 'us') {
                        response.data.user.language = 'en';
                    }
                    // Token from cookie checks out.  Carry on
                    CoreCompanyService.setCurrent(response.data.company);
                    CoreUserService.setCurrent(response.data.user, doCheckUserTimezone);

                    $rootScope.currentCompanyName = current.name;
                    $rootScope.currentUserName = CoreUserService.getName();
                    $rootScope.$broadcast('companyChanged', current);
                } else {
                    // Something not right about token.  Considering expired
                    token = null;

                    // If we couldn't find the current user, your session probably isn't valid...
                    if (response.status === 404) {
                        CoreUserService.logout();
                    }
                }
            })
            .catch(function () {
                // Something not right about token.  Considering expired
                token = null;
            });
    };

    if ($cookies.get('gydaToken') !== undefined) {
        var cookie = $cookies.getObject('gydaToken');
        token = cookie.token;

        // We did not get a loginPayload, but we have a cookie.  Try to see if that's still a valid company
        loadCurrentAuthenticatedCompany();
    }

    EntitlementService.registerEntitlement(EntitlementService.LIMIT_TYPE, CoreUserService.USERS_ENTITLEMENT, 'users')
        .getUsed = function () {
            var deferred = $q.defer(),
                queryParams = {isInternal: false}; // don't want to count internal users against entitlement limit

            CoreCompanyService.getUsersByCompanyId(CoreCompanyService.getId(), queryParams).then(function (users) {
                deferred.resolve(users.length);
            }).catch(deferred.reject);

            return deferred.promise;
        };

    return CoreCompanyService;
}])
.service('company', ['$injector', function($injector) {
	return $injector.get('CoreCompanyService');
}]);